/* eslint-disable */
import axios from '../axios-config';
import QRP from '../../config/QRP.env';
import commonService from '../services/common';
import moment from 'moment';

export const quoteMixin = {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
    }
  },
  methods: {
    newQuoteSubmit() {
      sessionStorage.removeItem('autobound');
      sessionStorage.removeItem('homebound');
      sessionStorage.removeItem('selectedQuote');
      sessionStorage.removeItem('flowType');
      sessionStorage.removeItem('currentNav');
      sessionStorage.removeItem('homeSessionData');
      sessionStorage.removeItem('condoSessionData');
      sessionStorage.removeItem('renterSessionData');
      sessionStorage.removeItem('autoSessionData');
      sessionStorage.removeItem('setRc2NavFlowAction');
      sessionStorage.removeItem('autoRC1BindResponse');
      sessionStorage.removeItem('checkoutNav');
      sessionStorage.removeItem('autoPageName');
      sessionStorage.removeItem('homeRC2pagename');
      sessionStorage.removeItem('selectedCarrierAuto');
      sessionStorage.removeItem('selectedCarrierHome');
      sessionStorage.removeItem('autoBindDetails');
      sessionStorage.removeItem('homeBindDetails');
      this.$store.dispatch('setForceBindSuccessful', false);
      // set start time and page name for tracking purpose
      this.$store.dispatch('setStartTime');
      this.$store.dispatch('setPageActionName', 'CreateQuote');
      const that = this;
      that.custom_error_message = '';
      this.$validator.detach('zipcode'); // Detach/reattach ZIP code validation because Find Quote changes it
      this.$validator.detach(this.insuranceType.field_name);
      this.$validator.detach('emailOrPhone');
      this.$validator.detach('dob');
      if (this.formData.ep !== '') { // if email or phone field is entered then validate email or phone.
        if (this.formData.ep.indexOf('@') !== -1) {
          this.$validator.attach({
            name: 'emailOrPhone',
            rules: 'email',
            getter: () => that.formData.ep,
          });
        } else {
          this.$validator.attach({
            name: 'emailOrPhone',
            rules: { regex: /^(\d{3})-?(\d{3})-?(\d{4})$/ },
            getter: () => that.formData.ep,
          });
        }
      }
      this.$validator.attach({
        name: 'zipcode',
        rules: 'required|digits:5',
        getter: () => that.formData.zip,
      });
      this.$validator.attach({
        name: this.insuranceType.field_name,
        rules: 'required',
        getter: () => this.insuranceType.field_value,
      });
      this.$validator.attach({
        name: 'dob',
        rules: { date_format: 'MM/DD/YYYY', within_year_range: [108, 16, 'MM/DD/YYYY'] },
        getter: () => that.formData.dob,
      });

      this.$validator.validateAll().then((result) => {
        if (!result) {
          if (this.errors.has('emailOrPhone')) {
            this.$refs.emailOrPhone.focus();
          } else if (this.errors.has('insurance_type')) {
            document.getElementById('Auto').focus();
          } else if (this.errors.has('zipcode')) {
            this.$refs.zipcode.focus();
          } else if (this.errors.has('fname')) {
            this.$refs.fname.focus();
          } else if (this.errors.has('lname')) {
            this.$refs.lname.focus();
          } else if (this.errors.has('dob')) {
            document.getElementById('dob_masked').focus();
          }
          return;
        }
        if (this.formData.ep && this.formData.ep !== '') {
          if (this.formData.ep.indexOf('@') === -1) {
            this.formData.phone = this.formData.ep.replace(/-/g, '');
          }
          if (this.formData.ep.indexOf('@') !== -1) {
            this.formData.email = this.formData.ep;
          }
        }
        sessionStorage.setItem('quoteSummaryStatus', 'visible');
        /* call Create Quote Bundle API */
        axios.post('/autoquotes/quotebundle').then(async (response) => {
          let quotebundleID = response.data;
          // add current action in session storage to manage quote summary modal behavior
          sessionStorage.setItem('currentActionName', 'CreateQuote');
          if (this.insuranceType.field_value === QRP.PRODUCTS.HA_BUNDLE) {
            let homeQuoteResponse = await this.createQuote(QRP.PRODUCTS.HOME, quotebundleID);
            if (homeQuoteResponse) {
              let autoQuoteResponse = await this.createQuote(QRP.PRODUCTS.AUTO, quotebundleID);
              if (autoQuoteResponse) {
                // log API response time through application into GA tool
                commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'CreateQuoteAPI', 'Search');
                this.$store.dispatch('createQuote', homeQuoteResponse);
                this.$store.dispatch('setCurrentNav', homeQuoteResponse.data.Link);
                let routeName = commonService.getRouteName(homeQuoteResponse.data.Link);
                // sessionStorage.setItem('currentNav', 'homerc1');
                this.$router.replace(routeName);
              }
            }
          } else if (this.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE) {
            let quoteResponse = await this.createQuote(QRP.PRODUCTS.CONDO, quotebundleID);
            if (quoteResponse) {
              let autoQuoteResponse = await this.createQuote(QRP.PRODUCTS.AUTO, quotebundleID);
              if (autoQuoteResponse) {
                // log API response time through application into GA tool
                commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'CreateQuoteAPI', 'Search');
                this.$store.dispatch('createQuote', quoteResponse);
                this.$store.dispatch('setCurrentNav', quoteResponse.data.Link);
                let routeName = commonService.getRouteName(quoteResponse.data.Link);
                // sessionStorage.setItem('currentNav', 'homerc1');
                this.$router.replace(routeName);
              }
            }
          } else if (this.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE) {
            let quoteResponse = await this.createQuote(QRP.PRODUCTS.CONDO, quotebundleID);
            if (quoteResponse) {
              let autoQuoteResponse = await this.createQuote(QRP.PRODUCTS.AUTO, quotebundleID);
              if (autoQuoteResponse) {
                // log API response time through application into GA tool
                commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'CreateQuoteAPI', 'Search');
                this.$store.dispatch('createQuote', quoteResponse);
                this.$store.dispatch('setCurrentNav', quoteResponse.data.Link);
                let routeName = commonService.getRouteName(quoteResponse.data.Link);
                // sessionStorage.setItem('currentNav', 'homerc1');
                this.$router.replace(routeName);
              }
            }
          } else if (this.insuranceType.field_value === QRP.PRODUCTS.RA_BUNDLE) {
            let quoteResponse = await this.createQuote(QRP.PRODUCTS.RENTERS, quotebundleID);
            if (quoteResponse) {
              let autoQuoteResponse = await this.createQuote(QRP.PRODUCTS.AUTO, quotebundleID);
              if (autoQuoteResponse) {
                // log API response time through application into GA tool
                commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'CreateQuoteAPI', 'Search');
                this.$store.dispatch('createQuote', quoteResponse);
                this.$store.dispatch('setCurrentNav', quoteResponse.data.Link);
                let routeName = commonService.getRouteName(quoteResponse.data.Link);
                // sessionStorage.setItem('currentNav', 'homerc1');
                this.$router.replace(routeName);
              }
            }
          } else {
            let createQuoteresponse = await this.createQuote(this.insuranceType.field_value, quotebundleID);
            if (createQuoteresponse) {
              // log API response time through application into GA tool
              commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'CreateQuoteAPI', 'Search');
              this.$store.dispatch('createQuote', createQuoteresponse);
              this.$store.dispatch('setCurrentNav', createQuoteresponse.data.Link);
              let routeName = commonService.getRouteName(createQuoteresponse.data.Link);
              this.$router.replace(routeName);
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      }).catch((err) => {
        console.log('Error', err);
      });
    },
    async createQuote(productTypeId, quotebundleID) {
      let addQuoteResponse = false;
      let quoteResponse;
      let tempDob = this.formData.dob;
      if (tempDob !== '') {
        tempDob = moment(tempDob, 'MM/DD/YYYY').format('YYYYMMDD');
      }
      // route to named insured will be here
      /* call create quote API */
      await axios.post('/autoquotes/', {
        SessionId: '',
        FirstName: this.formData.fname.trim(),
        LastName: this.formData.lname.trim(),
        DOB: tempDob,
        City: '',
        State: '',
        ZipCode: this.formData.zip,
        Email: this.formData.email,
        PhoneNumber: this.formData.phone,
        productTypeId: productTypeId,
      },
      ).then(async (response) => {
        quoteResponse = response;
        if (this.insuranceType.field_value === QRP.PRODUCTS.HA_BUNDLE) {
          sessionStorage.setItem('flowType', 'bundle');
          if (productTypeId === QRP.PRODUCTS.HOME) {
            sessionStorage.setItem('sessionData', JSON.stringify(response.data));
            sessionStorage.setItem('homeSessionData', JSON.stringify(response.data));
          } else {
            sessionStorage.setItem('autoSessionData', JSON.stringify(response.data));
          }
        } else if (this.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE) {
          sessionStorage.setItem('flowType', 'cabundle');
          if (productTypeId === QRP.PRODUCTS.CONDO) {
            sessionStorage.setItem('sessionData', JSON.stringify(response.data));
            sessionStorage.setItem('condoSessionData', JSON.stringify(response.data));
          } else {
            sessionStorage.setItem('autoSessionData', JSON.stringify(response.data));
          }
        } else if (this.insuranceType.field_value === QRP.PRODUCTS.RA_BUNDLE) {
          sessionStorage.setItem('flowType', 'rabundle');
          if (productTypeId === QRP.PRODUCTS.RENTERS) {
            sessionStorage.setItem('sessionData', JSON.stringify(response.data));
            sessionStorage.setItem('renterSessionData', JSON.stringify(response.data));
          } else {
            sessionStorage.setItem('autoSessionData', JSON.stringify(response.data));
          }
        } else {
          sessionStorage.setItem('flowType', this.insuranceType.field_value);
          sessionStorage.setItem('sessionData', JSON.stringify(response.data));
        }

        if (response.data.Errors.length > 0) {
          this.createQuoteErrs = response.data.Errors;
        } else {
          addQuoteResponse = await this.addQuoteToBundle(response.data.SessionId, quotebundleID);
        }
      }).catch((error) => {
        console.log(error);
      });
      if (addQuoteResponse) {
        return quoteResponse;
      }
      return addQuoteResponse;
    },
    async addQuoteToBundle(SessionId, quotebundleID) {
      let addQuoteStatus = false;
      await axios.post('/autoquotes/quotebundle/addquote', {
        SessionId: SessionId,
        BundleId: quotebundleID,
      },
      ).then((response) => {
        addQuoteStatus = response.data;
      }).catch((error) => {
        addQuoteStatus = false;
        console.log(error);
      });
      return addQuoteStatus;
    },
  },
};


// WEBPACK FOOTER //
// ./src/mixins/quoteMixin.js